module.exports = __webpack_public_path__ + "049585e63ca46fbe63e7dbbd24ca0530.mp3";